import { render } from "./BirthdayBalloons.vue?vue&type=template&id=2dff0073&scoped=true"
import script from "./BirthdayBalloons.vue?vue&type=script&lang=js"
export * from "./BirthdayBalloons.vue?vue&type=script&lang=js"

import "./BirthdayBalloons.vue?vue&type=style&index=0&id=2dff0073&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dff0073"]])

export default __exports__